import React, { useEffect } from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import { useAppointmentModel } from "../appointmentModel";

import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function PageHeader() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, rolesAllList, setLocale } = useGlobalModel();
    
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();

    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAppointmentModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "客户名称",
            placeholder: setLocale(LanguageArr)["Customer"],
            fieldName: "customerName",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: setLocale(LanguageArr)["Contact"],
            fieldName: "contact",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: setLocale(LanguageArr)["Status"],
            // placeholder: "单据状态",
            fieldName: "status",
            options: getSelectedDictOne(DictCodeEnmu.APPOINTMENT)
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: setLocale(LanguageArr)["AppointmentDocNo"],
            // placeholder: "单据编号",
            fieldName: "appointmentCode"
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: setLocale(LanguageArr)["ServiceType"],
            // placeholder: "维修类型",
            fieldName: "serviceTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE)
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: setLocale(LanguageArr)["License Plate"],
            // placeholder: "车牌号",
            fieldName: "licensePlate"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: setLocale(LanguageArr)["VIN"],
            // placeholder: "VIN码",
            fieldName: "vin"
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            // placeholder: ["制单日期起始", "制单日期结束"],
            placeholder: [setLocale(LanguageArr)["CreationStartTime"], setLocale(LanguageArr)["CreationEndTime"]],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        }
    ]
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{setLocale(LanguageArr)["CreateBusinessDocs"]} </span>
        <span style={{ color: "#000" }}>/ {setLocale(LanguageArr)["MaintenanceAppointment"]}</span>
    </>
    return (
        <>
            <YhPageHeader
                title={PageHeaderTitle}
                // size="small"
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                handleSearch={loadData}
                handleReset={resetSearchParam}
            />
        </>
    );
}